/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CRMAuftrag } from '../models/CRMAuftrag';
import type { CRMAuftragMitBerechtigungen } from '../models/CRMAuftragMitBerechtigungen';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CrmAuftragService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * @param requestBody
   * @returns CRMAuftragMitBerechtigungen der erstellte CRMAuftrag
   * @throws ApiError
   */
  public erstelleCrmAuftrag(
    requestBody: CRMAuftrag,
  ): CancelablePromise<CRMAuftragMitBerechtigungen> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/crm-auftraege',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }

}
